import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const cart = JSON.parse(localStorage.getItem('cart') || '[]');
    setCartCount(cart.reduce((sum: number, item: any) => sum + item.quantity, 0));

    const handleStorageChange = () => {
      const updatedCart = JSON.parse(localStorage.getItem('cart') || '[]');
      setCartCount(updatedCart.reduce((sum: number, item: any) => sum + item.quantity, 0));
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('cartUpdated', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('cartUpdated', handleStorageChange);
    };
  }, [location]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Products', path: '/products' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
    { name: 'FAQ', path: '/faq' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-black'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img 
            src="https://static.readdy.ai/image/a527149075599ef0f11873d3eee8c9c7/71fa8bbc36f7c1207af84c51d8954141.png" 
            alt="Tech Cell Corp. Logo" 
            className="h-32 w-auto"
          />
        </Link>

        <nav className="flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === link.path
                  ? isScrolled ? 'text-[#FF6B6B]' : 'text-white'
                  : isScrolled ? 'text-gray-700 hover:text-[#FF6B6B]' : 'text-white/90 hover:text-white'
              }`}
            >
              {link.name}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-5">
          <button 
            className={`w-6 h-6 flex items-center justify-center cursor-pointer transition-colors ${
              isScrolled ? 'text-gray-700 hover:text-[#FF6B6B]' : 'text-white hover:text-white/80'
            }`}
            aria-label="Search"
          >
            <i className="ri-search-line text-xl"></i>
          </button>
          
          <Link 
            to="/cart" 
            className={`w-6 h-6 flex items-center justify-center cursor-pointer relative transition-colors ${
              isScrolled ? 'text-gray-700 hover:text-[#FF6B6B]' : 'text-white hover:text-white/80'
            }`}
            aria-label="Shopping Cart"
          >
            <i className="ri-shopping-cart-line text-xl"></i>
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-[#FF6B6B] text-white text-xs w-5 h-5 flex items-center justify-center rounded-full font-semibold">
                {cartCount}
              </span>
            )}
          </Link>
          
          <button 
            className={`w-6 h-6 flex items-center justify-center cursor-pointer transition-colors ${
              isScrolled ? 'text-gray-700 hover:text-[#FF6B6B]' : 'text-white hover:text-white/80'
            }`}
            aria-label="User Account"
          >
            <i className="ri-user-line text-xl"></i>
          </button>
        </div>
      </div>
    </header>
  );
}
